function logger(...args) {
  throw new Error(args);
}
const instance = {
  notify: logger
};
export default instance;
